// @example ```js
// const str = Hello {name}
// const values = { name: 'Test' }
// interpolateStringUtil(str, values) // returns 'Hello Test'
// ```
//
export default function interpolateStringUtil (str = '', values = {}) {
  const strArr = str.split(/{([\s\S]+?)}/g)
  return strArr.reduce((finalStr, chunk, index) => {
    if (index % 2) {
      finalStr += (values?.[chunk] || '') + ''
    } else {
      finalStr += chunk
    }
    return finalStr
  }, '')
}
